import {Injectable} from '@angular/core';
import * as marked from 'marked';
import {Slugger, TokensList} from 'marked';

@Injectable({
  providedIn: 'root',
})
export class MarkedService {
  createSlugger(): Slugger {
    return new marked.Slugger();
  }

  slug(value: string): string {
    const slugger = new marked.Slugger();
    return slugger.slug(value);
  }

  lex(src: string): TokensList {
    return marked.lexer(src);
  }

  parse(tokenList: TokensList) {
    return marked.parser(tokenList);
  }
}
